<template>
  <v-container>
      <!--(팝업)개인 정보 변경-->
      <v-dialog
        v-model="persondialog" @keydown.esc="persondialog = false"
        max-width="600px"
        persistent>
        <v-card id="popStyle03">
          <!--팝업 제목-->
          <v-card-title class="title">
            <div class="popCon_txt">
              <v-tabs v-model="tabs" class="popSet_userinfo">
                <v-tab>개인정보 변경</v-tab>
              </v-tabs>
            </div>
          </v-card-title>
          <!--팝업 내용-->
          <v-card-text>
            <v-row no-gutters class="popCon">
              <v-tabs-items v-model="tabs">
                <v-tab-item>
                  <v-col cols="12" class="pd-0">
                    <div class="txtst_info_gray row_mb-20">* 아이디/이메일은 변경할 수 없습니다.</div>
                  </v-col>
                  <v-col cols="12" class="pd-0">
                    <v-text-field class="inputH48_01 row_mb-8"
                      label="아이디"
                      v-model="personform.userid"
                      value= personform.userid
                      outlined
                      disabled
                    >
                    </v-text-field>
                    <v-text-field class="inputH48_01 row_mb-8"
                      label="이메일"
                      v-model="personform.email"
                      value= personform.email
                      outlined
                      disabled
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" class="popCon_input_W100_cov pd-0">
                    <v-text-field class="inputH48_01 conBstar row_mb-8"
                      label="이름"
                      ref="personformName"
                      v-model="personform.name"
                      :rules="rules.nameRequireRules"
                      value= personform.name
                      maxlength="200"
                      outlined
                    >
                    </v-text-field>
                    <v-text-field class="inputH48_01 conBstar row_mb-8"
                      label="연락처"
                      ref="personformPhone"
                      v-model="personform.phone"
                      :rules="rules.phoneRequireRules"
                      value= personform.phone
                      maxlength="100"
                      outlined
                    >
                    </v-text-field>
                    <v-text-field class="inputH48_01 W100 conBstar row_mb-8"
                      label="주소"
                      ref="personformAddr"
                      v-model="personform.addr_main"
                      :rules="rules.addressRequireRules"
                      value= personform.addr_main
                      maxlength="2000"
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                </v-tab-item>
              </v-tabs-items>
            </v-row>
          </v-card-text>
  
          <!--팝업 버튼-->
            <v-tabs-items v-model="tabs">
                <v-tab-item>
                  <v-card-actions class="justify-center">
                    <v-btn class="btn_C01" text  @click="saveUserInfo()" >확인</v-btn>
                    <v-btn text @click="persondialog = false">취소</v-btn>
                  </v-card-actions>
                </v-tab-item>
            </v-tabs-items>
          <!--/팝업 버튼-->
        </v-card>
      </v-dialog>
      <s-loading ref="loading"></s-loading>
      <s-confirm ref="confirm"></s-confirm>
      </v-container>
  </template>
  
  <script>
  import store from '@/store'
  import { modifyUserInfo } from '@/api/user'
  
  export default {
    name: 'person',
    components: {
    },
    props:{
      accountform: {}
    },
    filters: {
      regNumFilter: function (value) {
        if (value) {
          return String(value).replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3')
        }
      }
    },
    data () {
      return {
        rules: {
          nameRequireRules: [
            v => !!v || '이름을 입력해주세요.',
          ],
          addressRequireRules: [
            v => !!v || '주소를 입력해 주세요.',
          ],
          phoneRequireRules: [
            v => !!v || '핸드폰 번호를 입력해주세요.',
            v => (/^(01[016789]{1})([0-9]{7,8})$/.test(v) && v.length !==0 ) || '핸드폰 형식을 확인해 주세요'
          ],
        },
        userDelYn: 1,
        persondialog: false,
        tabs: null,
        dialog01: true,
        personform: {
          userid: '',
          name: '',
          email: '',
          addr_main: '',
          phone: ''
        },
        pass_form: {
          old_password: '',
          password: '',
          password_re: ''
        },
        passChangeform: {
          userid: '',
          name: '',
          email: '',
          addr_main: '',
          phone: '',
          old_password: '',
          password: ''
        },
        listParam: {
          page: 0,
          size: 10
        },
        searchData: {
          selectValue: '',
          fromDataValue: '',
          toDataValue: '',
          metaData: [],
          dateChecker: '',
          keyword: []
        },
      }
    },
    created () {
    },
    mounted () {
      this.userid = this.$store.state.user.userid
    },
    methods: {
      open() {
        this.persondialog = true
        this.personform = this.accountform
        this.personform.phone = this.personform.phone.replaceAll('-', '')
      },
      saveUserInfo () {
        if (this.$refs.personformName.validate() && this.$refs.personformPhone.validate() && this.$refs.personformAddr.validate()) {
          this.$refs.loading.start('입력 정보 확인 중')
          this.$nextTick(() => {
            modifyUserInfo(JSON.stringify({ user: this.personform })).then(Response => {
              if (Response.rdata !== undefined && Response.rdata.rcode === 20000) {
                this.$refs.loading.end()
                this.personform.userid = Response.rdata.user.userId
                this.personform.name = Response.rdata.user.userName
                this.personform.email = Response.rdata.user.userEmail
                this.personform.addr_main = Response.rdata.user.userAddress
                this.personform.phone = Response.rdata.user.userCtr
                store.dispatch('updateUsrdata', Response.rdata.user).then(() => {
                })
                this.$refs.confirm.open('alert', '개인정보 변경', '개인정보 변경이 완료되었습니다')
                this.persondialog = false
              } else {
                this.$refs.loading.end()
                var msg = ''
                if (Response.rdata === undefined) {
                  msg = Response.message
                } else {
                  msg = Response.rdata.message
                }
                this.$refs.confirm.open('alert', '개인정보 변경', msg)
                this.persondialog = false
              }
            })
          })
        } else {
          this.$refs.confirm.open('alert', '개인정보 변경', '입력하신 개인정보를 확인해주세요.')
        }
      }
    }
  }
  </script>
  